import { useEditorRef } from 'platejs/react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@mui/material';

import { EDITOR_FILE_MAX_SIZE } from 'common/constants/files';
import { options } from 'common/components/ContentEditor/options';

import { addOrReplaceFile } from './utils';
import { FileUpload } from './FileUpload';

interface IProps {
    file?: typeof options.file;
}

export const BlockMenuFile = ({ file: _file = options.file }: IProps) => {
    const editor = useEditorRef();
    const { t: translate } = useTranslation();

    const handleSuccess = (url: string, name?: string) => {
        addOrReplaceFile(editor, url, name);
    };

    return (
        <FileUpload
            component={MenuItem}
            id="menu-file-upload"
            maxSize={EDITOR_FILE_MAX_SIZE}
            onSuccess={handleSuccess}
        >
            {translate('edit')}
        </FileUpload>
    );
};
